// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1oUl4","inputWrap":"Table_inputWrap__IrkRT","col":"Table_col__2CBHM","bmiTooltip":"Table_bmiTooltip__3rkWq"};